export default __webpack_public_path__ + "static/rff-mo-sw-20f811bec672374428d8d9a4c52b2cf6.png";